<template>
  <div id="nav">


    <ul>
      <!-- <li><a href="http://bosastrology.com">About</a></li> -->
      <!-- <li><a href="http://bosastrology.com">Dictionary</a></li> -->
      <li><a href="https://bosastrology.com">Zodiac Signs</a></li>
      
      <li><router-link to="/"><div >
            <img alt="BOS logo" src="../assets/img/BOS-Logo-dark.png" height="50" ></div></router-link></li>
      <!-- <li><router-link to="/findmysign">Find My Sign</router-link></li> -->
      <!-- <li><router-link to="/calendar/">Moon Calendar</router-link></li> -->
      <li><a href="/calendar/">Moon Calendar</a></li>
      <!-- <li><a href="http://bosastrology.com">Products</a></li> -->
      <!-- <li><a href="http://bosastrology.com">Contact</a></li> -->

   </ul>

  </div>
</template>


<script>
export default {

};
</script>



<style scoped>

#nav {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 10vh;
  /* background-color: red; */

}

#nav a {
  font-weight: bold;
  /* color: #2c3e50; */
  color:white;
    text-shadow: -1px 0px 3px rgba(0, 0, 0, 1);
}



#nav a.router-link-exact-active {
  color: #42b983;
}

/* .buttonTxt, a, .signDisplayName{
    color:white;
    text-shadow: -1px 0px 3px rgba(0, 0, 0, 1);
}
 */

/* .inline {
  position:relative;
  display: inline-flex;
  padding: 5px;
  margin: 5px; 
  } */

ul li {
  display: inline-block;
  vertical-align: middle;

}
ul li a, ul li router-link {
    margin: 0 1em;
    font-size: 3vh;
}
ul{
    display: block;
    list-style-type: none;
    margin-block-start: 0px;
    margin-block-end: 0px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
}
</style>
